import React, { useEffect, useState } from 'react';
import { Card, Spinner, Alert } from 'react-bootstrap';
import Chart from 'react-apexcharts';
import { getTelematicsErrorChartOptions } from '../configs/chartConfigs';
import { generateTelematicsErrorDataFromAPI } from '../utils/dataGenerators';
import { gettelematicserrormetrics } from '../../../service/telemetricDashboardService';
import { buildFilterObject } from '../utils/filterUtils';

const TelematicsErrorChart = ({ chartFilters }) => {
	const [telematicsErrorData, setTelematicsErrorData] = useState({ categories: [], series: [] });
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchTelematicsErrorData = async () => {
			try {
				setLoading(true);
				setError(null);
				const filters = buildFilterObject(chartFilters);
				const response = await gettelematicserrormetrics(filters);
				const transformedData = generateTelematicsErrorDataFromAPI(response.data);
				setTelematicsErrorData(transformedData);
			} catch (err) {
				console.error('Error fetching telematics error data:', err);
				setError('Failed to load telematics error data');
			} finally {
				setLoading(false);
			}
		};

		fetchTelematicsErrorData();
	}, [chartFilters.siteids, chartFilters.vehiclemodels, chartFilters.vehicletypes]); // Only watch relevant filters

	const telematicsErrorOptions = getTelematicsErrorChartOptions(telematicsErrorData.categories);

	return (
		<Card>
			<Card.Header>
				<div className="d-flex justify-content-between align-items-center">
					<span>Telematics Errors</span>
					<div className="d-flex align-items-center">
						<span className="badge bg-secondary">last 7 days</span>
					</div>
				</div>
			</Card.Header>
			<Card.Body>
				<div className="mb-3">
					<small>X-axis: Time (7 days) | Y-axis: Error Count | Type: Stacked Column Chart</small>
				</div>
				{loading ? (
					<div className="text-center py-5">
						<Spinner animation="border" role="status">
							<span className="visually-hidden">Loading...</span>
						</Spinner>
					</div>
				) : error ? (
					<Alert variant="danger">{error}</Alert>
				) : telematicsErrorData.series.length === 0 ? (
					<Alert variant="info">No telematics error data available for the last 7 days</Alert>
				) : (
					<Chart
						options={telematicsErrorOptions}
						series={telematicsErrorData.series}
						type="bar"
						height={350}
					/>
				)}
			</Card.Body>
		</Card>
	);
};

export default TelematicsErrorChart;
